import script from "./RegisteringI18n.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisteringI18n.vue?vue&type=script&setup=true&lang=ts"

import "./RegisteringI18n.vue?vue&type=style&index=0&id=0e9f7f62&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e9f7f62"]])

export default __exports__